import tabBar from './tabBar/tabBar.vue' // 底部tabBar
import navTab from './nav_tab/nav_tab.vue' // 搜索导航
import searchList1 from './search_item/search_item1.vue' // 课程搜索列表
import searchList2 from './search_item/search_item2.vue' // 课程搜索列表
import courseTabBarList from './courseTabBar/courseTabBar.vue' // 课程详情tab
import AdminSearch1 from './search_item/administration_search1.vue' // 管理搜索列表
import AdminSearch2 from './search_item/administration_search2.vue' // 管理搜索列表
import Options from './options/options.vue' // 试卷选项
import Options2 from './options/options2.vue' // 试卷选项
import MyOption from './options/myOption.vue' // 我的考核试卷
import Progress from './van-progress.vue' // 进度条
import PDF from './pdf/index.vue' // 在线展示pdf
import ShowPDF from './pdf/pdf.vue'
import Video from './video.vue'
import HeaderTop from './headerTop.vue'
export default Vue=>{
    Vue.component('v-tab-bar',tabBar)
    Vue.component('nav-tab',navTab)
    // Vue.component('search-list-1',searchList1)
    // Vue.component('search-list-2',searchList2)
    Vue.component('courseTabBarList',courseTabBarList)
    // Vue.component('adminSearch1',AdminSearch1)
    // Vue.component('adminSearch2',AdminSearch2)
    Vue.component('my-options',Options);
    Vue.component('my-options2',Options2);
    Vue.component('my-options3',MyOption);
    Vue.component('my-progress',Progress);
    Vue.component('pdf', PDF);
    Vue.component('show-pdf', ShowPDF);
    Vue.component('m-video',Video);
    Vue.component('m-headerTop',HeaderTop);
}


// WEBPACK FOOTER //
// ./src/components/index.js